/*************************************************************************
 * 
 * KLEAREXPRESS CONFIDENTIAL
 * __________________
 * 
 *  Copyright (c) 2018 - 2018 KlearExpress Corporation.
 *  All Rights Reserved.
 * 
 * NOTICE:  All information contained herein is, and remains
 * the property of KlearExpress Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KlearExpress Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KlearExpress Corporation.
 */


import React, { Component } from 'react';
import './styles/css/add-team.css';
import { Button, Icon, Segment, Form, Container, Header, Checkbox, Popup, Grid, Input, Select, List, Progress} from 'semantic-ui-react';
import { Redirect, Link } from 'react-router-dom';
import API from '../utility/API';
import ProgressBar from "../components/progress-bar";

class AddTeam extends Component {
    constructor() {
        super();
        this.state = {
            toNextPage: false,
            progress: 100,
            teamData: [],
            hideCarrot: false,
            isOpen: false
        }
    }

    handleChange = (e, { name, value }) => this.setState({ [name]: value }, console.log(this.state))

    getCookieValue = (name) => {
        var b = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
        return b ? b.pop() : '';
    }

    onSubmit = (val) => {
        this.setState({hideCarrot: true})
        this.setState({isOpen: false})
        const {teamData, fullName, email, role} = this.state
        const teamMember = {fullName, email, role}
        this.setState({ teamData: [...teamData, teamMember],
        fullName:'', email: '', role: ''
        }, console.log(this.state.teamData))
    }

    onFinalSubmit = () => {
        API.addTeam(
            this.getCookieValue('kxCustomerToken'),
            this.state.teamData
        ).then(response => {
            return response.json()
        }).then(() => this.setState(() => ({
			toNextPage: true
		}))
		).catch(err => console.log('ERROR:', err))
    }

    handleSkip = () => {
        this.props.storeProgressData("addTeam", "piece progress-gray")
      }

    handleOpen = () => {
        this.setState({isOpen: true})
    }

    handleClose = () => {
        this.setState({isOpen: false})
    }

    render() {

        const options = [
            { key: 'LM', text: 'Logistics Manager', value: 'Logistics Manager'},
            { key: 'W', text: 'Warehouse', value: 'Warehouse'},
            { key: 'S', text: 'Sales', value: 'Sales'},
            { key: 'P', text: 'Procurements', value: 'Procurements'}
        ]

        if (this.state.toNextPage === true) {
            this.props.storeProgressData("addTeam", "piece progress-green")
            return <Redirect to='/finish' /> 
          }

        return (
            <div id="add-team-page">

                <ProgressBar progressData={this.props.progressData}/>

                <Segment padded='very' className="team-container" raised>
                    <Header as='h1'>Invite your team</Header>
                    <p className='add-team-blurb'>You can provide basic information about your team members and we will do the rest to send invites and build their access and permissions. 'Add Users' to get started.</p>
                    <Container id="teamMembers" className="add-team-container">
                    
                    <center>
                    {this.state.teamData ?
                    <List id ="add-team-list" divided relaxed size={'large'}>
                        {this.state.teamData.map((item, i) =>(
                            
                            <List.Item>
                                <List.Content>
                                    <Grid>

                                        <Grid.Row id="add-team-first-row" columns={2}>
                                            <Grid.Column id="add-team-first-column" floated ='left' width={5}>
                                                <p className="teamName addTeamList">{item.fullName}</p>
                                            </Grid.Column>
                                            <Grid.Column floated='right' width={5}>
                                            <p className="teamRole addTeamList">{item.role}</p>
                                        </Grid.Column>
                                        </Grid.Row>

                                        <Grid.Row>
                                            <p className="teamEmail addTeamList">{item.email}</p> <br />
                                        </Grid.Row>
                                    </Grid>
                                </List.Content>
                            </List.Item>
                        ))}
                    </List> :
                        null}

                    </center>

                    <center>
                        <div className='add-team'>
                            <Popup
                                id="add-team-popup"
                                trigger={<Icon onClick={this.handleOpen} name="add" circular color="blue" className="add-team-member" size='big' />}
                                basic={this.state.hideCarrot}
                                open={this.state.isOpen}
                                content={
                                    <Form>
                                        <Form.Field>
                                            <label className="add-team-label">NAME</label>
                                            <Input  
                                                name="fullName" 
                                                value={this.state.fullName}
                                                className="add-team-input"
                                                placeholder='Joseph Murphy'
                                                onChange={this.handleChange}
                                            />
                                            <label className="add-team-label">EMAIL</label>
                                            <Input 
                                                name="email" 
                                                value={this.state.email}
                                                className="add-team-input"
                                                placeholder='Joseph.Murphy@worldwidecompany.com'
                                                onChange={this.handleChange}
                                            />
                                            <label className="add-team-label">ROLE</label>
                                            <Select 
                                                name="role"
                                                value={this.state.role}
                                                className="add-team-select" 
                                                options={options} 
                                                placeholder="Please select a role" 
                                                onChange={this.handleChange}
                                            />
                                        </Form.Field>

                                        <Button 
                                            className="add-team-submit" 
                                            color="twitter" 
                                            content="Add & Invite"
                                            onClick={this.onSubmit}
                                        />

                                        <Button 
                                            className="add-team-cancel" 
                                            color="twitter" 
                                            content="Cancel"
                                            onClick={this.handleClose}
                                        />

                                    </Form>
                                }
                                on='click'
                                position="bottom center"
                                wide="very"
                            />
                        </div>
                    </center>
                    </Container>
                </Segment>

                                <div className="add-team-buttonRow">
                {/* <Link to='./accountInfo3'> */}
                    <Button type='submit' className="add-team-skip" onClick={this.handleSkip}>SKIP THIS</Button>
                {/* </Link> */}
                {/* <Link to='./accountInfo3'> */}
                    <Button type='submit' className="add-team-save" color="twitter" onClick={this.onFinalSubmit}>SAVE & NEXT</Button>
                {/* </Link> */}
                </div>
            </div>
        )
    }
}

export default AddTeam;